<template>
  <div class="all-work__group">
    <input class="all-work__group-input" type="checkbox" v-model="audioguides" name="audioguides" id="id_audioguides"/>
    <label class="all-work__group-label" for="id_audioguides">{{ audioguidesLabel }}</label>
  </div>
</template>


<script>
  import FilterAudioguidesMix from "../../../../../components/list/filter/FilterAudioguidesMix";

  export default {
    name    : 'filter-audioguides-sub',
    mixins: [FilterAudioguidesMix],

    data() {
      return {
        audioguidesLabel: this.$t("message.WithAudioguideSub"),
      }
    },
  }
</script>



// WEBPACK FOOTER //
// src/sub/_common/components/list/filter/FilterAudioguidesSub.vue